module.exports = __webpack_public_path__ + "bc042706fb5d60b934bef9a81bedd765.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/aspiration_funds.png
// module id = 1625
// module chunks = 0